import { createCache } from '../../utils';
import { PreloadableJSResource } from '../preloadable-js-resource';
import { postTask } from '../scheduler';
const cache = createCache(new Map());
export function JSResourceForInteraction(loader, opts) {
  return cache.get(opts.moduleId, () => PreloadableJSResource(() => postTask(loader, {
    priority: 'user-visible'
  }), opts));
}